import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, auth } from '../finance/shared';

export default function PaymentProofModal({ venueId, booking, onClose }) {
  const [url, setUrl] = useState(null);
  const [isPdf, setIsPdf] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl;
    axios.get(`${API}/venues/${venueId}/bookings/${booking.id}/payment-proof`, { ...auth(), responseType: 'blob' })
      .then((res) => {
        setIsPdf(res.headers['content-type'] === 'application/pdf');
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => setError(true));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [venueId, booking.id]);

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4" onClick={onClose} data-testid="payment-proof-modal">
      <div className="max-h-[85vh] w-full max-w-md overflow-y-auto rounded-2xl bg-white p-5" onClick={(e) => e.stopPropagation()}>
        <div className="mb-3 flex items-center justify-between">
          <h4 className="text-sm font-bold text-slate-900">إثبات دفع {booking.customer_name || ''}</h4>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="payment-proof-close-btn">✕</button>
        </div>
        {error ? (
          <p className="text-sm text-red-500" data-testid="payment-proof-error">تعذّر تحميل الإثبات</p>
        ) : !url ? (
          <div className="h-48 animate-pulse rounded-xl bg-slate-100" />
        ) : isPdf ? (
          <a href={url} target="_blank" rel="noreferrer" className="block rounded-xl border border-slate-200 p-4 text-center text-sm font-bold text-orange-600" data-testid="payment-proof-pdf-link">فتح ملف PDF</a>
        ) : (
          <img src={url} alt="إثبات الدفع" className="w-full rounded-xl object-contain" data-testid="payment-proof-image" />
        )}
      </div>
    </div>
  );
}
